import React from 'react'
import {connect} from 'react-redux';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import buscarItinerariosEmbarque from '../../actions/itinerario/buscarItinerariosEmbarque';
import Itinerarios from './Itinerarios';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getOperadorEmpresa,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import {alterouEmpresa} from '../../actions/empresa/alterarEmpresaSelecionada';
import {alterouFiltro, alterouPagina} from '../../util/filtros';
import PainelFiltragem from './PainelFiltrosItinerarioEmbarque';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoitinerarioEmbarque from './PaginacaoitinerarioEmbarque';
import BotoesPaginacaoItinerarioEmbarque from './BotoesPaginacaoItinerarioEmbarque';
import determinarPaginaAtualItinerarioEmbarque from '../../actions/itinerario/determinarPaginaAtualItinerarioEmbarque';

export class PainelPassageirosItinerario extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtualItinerarioEmbarque(1);        
    }

    componentDidMount() {        
        this.props.buscarItinerariosEmbarque(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados)
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.props.buscarItinerariosEmbarque(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados)
            if (!alterouPagina(this.props, prevProps)) {
                this.props.determinarPaginaAtualItinerarioEmbarque(1)
            }
        }
    
    }

    render() {
        return (<Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getMotoristaEmpresa(this.props.empresaSelecionada.id),
            getFiscalEmbarque(this.props.empresaSelecionada.id)]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <div className="col-md-12">
                <div className='col-md-12'>
                    <Titulo texto="Embarque de passageiros" urlRetorno="/menu-itinerario"/>
                    <div className="col-12 filtro-busca">
                            <PainelFiltragem/>
                    </div>
                </div>
                <div className='col-md-12 d-flex justify-content-center mt-2'>
                    <button onClick={() => this.props.history.push('/painel-embarque-com-qrcode')}
                            className="btn btn-laranja">EMBARCAR COM QRCODE
                    </button>
                </div>
                <div className='container-padrao mt-5'>
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoitinerarioEmbarque}
                                           BotoesPaginacao={BotoesPaginacaoItinerarioEmbarque}
                                           Itinerarios={this.props.itinerarios}
                                           empresaSelecionada={this.props.empresaSelecionada}>
                    <Itinerarios/>
                </CabecalhoRodapeTabela>
                </div>
            </div>
        </Autorizacao>)
    }
}

export function mapStateToProps(state) {
    return {
        reservas: state.reservas,
        itinerarios: state.itinerarios.itinerarios,
        itinerarioSelecionado: state.itinerarioSelecionado,
        filtrosAdicionados: state.filtrosAdicionadosItinerarioEmbarque,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualItinerarioEmbarque,
        registrosPorPagina: state.registrosPorPaginaAtualItinerarioEmbarque
    }
}


export default connect(mapStateToProps, {
    buscarItinerariosEmbarque,    
    determinarPaginaAtualItinerarioEmbarque
})(PainelPassageirosItinerario);
